import type { UploadMediaBodyType } from './uploadMediaBodyType';

export type UploadMediaBody = {
  /** 접근성을 위한 대체 텍스트 */
  altText?: string;
  /** 미디어에 대한 설명 */
  description?: string;
  /** 업로드할 미디어 파일 */
  file: Blob;
  /** 추가 메타데이터 (JSON 문자열) */
  metadata?: string;
  /** 미디어 파일 유형 */
  type?: UploadMediaBodyType;
};
